<template>
  <table>
    <thead v-bind:style="{ 'background-color':  reportColour}">
      <tr>
        <th>
          Pos
        </th>
        <th >
          Country
        </th>
        <th class="leftAlign">
          Name
        </th>
        <th >
          <span v-if="data.oom_type == 'points'">
            Points
          </span>
          <span v-else>
            {{data.value_2_head}}
          </span>
        </th>
        <th >
          Events Played
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(stats, index) in data.oom.oom_entry" :key="index" :class="{cutBK : stats.pos == 'CUT'}">
        <td class="cut" colspan="11"  v-if="stats.pos == 'CUT'">
          <template v-if="stats?.rookie1_image !== undefined">
          {{ stats.rookie1_image }}
          </template>
          <template v-else>
            CUT
          </template>
        </td>
        <td v-else>
          {{stats.pos}}
        </td>
        <td v-if="stats.pos != 'CUT'">
          <span>
            <img
              :class="flag"
              :src="
                (config.VUE_APP_FLAG_URL +
                  stats.nationality)
                  | lowercase
              "
            />
            {{stats.nationality}}
          </span>
        </td>
        <td class="leftAlign" v-if="stats.pos != 'CUT'">
          <a class="namelink"  @click="newtab(stats.playerno)">
            {{ stats.forename }} {{ stats.surname }} <span v-if="stats.sponsored == 'Y'"><img class="sponsorLogo" :src="data.sponsor_indicator_logo"></span>
          </a>
        </td>
        <td v-if="stats.pos != 'CUT'">
          {{ stats.oom_value}}
        </td>
        <td v-if="stats.pos != 'CUT'">
          {{ stats.tournaments_played }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "statsTable",
  props: ["id", "stat", "data", 'config'],
  data() {
    return {
      noData: "noData",
      flag: "flag",
      cell: "cell",
      fields: "fields",
      name: "name",
      reportColour: process.env.VUE_APP_REPORT_MAIN_COLOUR
    };
  },
  methods: {
        newtab: function (playerno) {   
        window.open("https://golf.com.au/pga-tour-aus#https://pga-tour-aus.ocs-software.com/playerprofile/" + playerno, "_blank");    
    },
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
};
</script>

<style scoped>

img.sponsorLogo {
    width: 40px;
    margin-left: 10px;
}
td.cut {
  color: #ffffff;
  text-align: left;
}
tr.cutBK {
  background-color: #00b588!important;
  color: #ffffff;
}
th.leftAlign {
  text-align: left;
}
td.leftAlign {
  text-align: left;
  width: 20%;
}
.namelink {
  color: #000!important;
}
.namelink:hover {
  color: #00b588!important;
  text-decoration: none;
}
table > tbody > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 0px solid #ddd;
  border-right: none !important;
  padding: 0.8em 0.5em 0.8em 1em !important;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  text-align: center;
}
 table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 0px solid #ddd;
  font-weight: bold;
  color: white;
  font-size: 13px;
  text-transform: capitalize;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  /* background: #00433e; */
  color: #ffffff !important;
  text-align: center;
}
table {
  width: 100%;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}

 tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.04);
  /* background-color: #dfe1e6; */
}
@media only screen and (max-width: 500px) {
  td.leftAlign {
    text-align: left;
    width: auto!important;
  }
}
</style>
